import {lazy} from 'react';
import {RouteType} from '../../global/types/route.type';
import {appRoutes} from './appRoutes';
import authRoute from './authRouteBinding';
import noAuthRoutes from './publicRoutesBinding';

export const publicRoutes: RouteType[] = [...noAuthRoutes];
export const authRoutes: RouteType[] = [...authRoute];

export const protectedRoutes: RouteType[] = [
    {
        key: 'MyWork',
        authorities: [],
        path: appRoutes.myWork.myWork(),
        component: lazy(() => import('views/myWork/MyWorkIndex')),
    },
    {
        key: 'WorkSpaceBoards',
        authorities: [],
        path: appRoutes.workspace.boardListing(),
        component: lazy(() => import('../../views/board/BoardIndex')),
        subRoute: [
            {
                key: 'ItemDataDialog',
                authorities: [],
                path: appRoutes.workspace.boadListingWithTicket(),
                component: lazy(() => import('../../views/board/ItemDataIndex')),
            },
        ],
    },
    {
        key: 'FetchData',
        authorities: [],
        path: appRoutes.workspace.fetchData(),
        component: lazy(() => import('../../views/board/BoardIndex')),
    },
    {
        key: 'MarketPlace',
        authorities: [],
        path: appRoutes.marketPalceRoutes.marketPlace(),
        component: lazy(() => import('../../views/marketPlace/MarketPlaceLayout')),
        subRoute: [
            {
                key: 'MarketPlaceDrawer',
                authorities: [],
                path: appRoutes.marketPalceRoutes.addNewMarketPlace(),
                component: lazy(() => import('../../views/marketPlace/MarkPlaceDrawer')),
            },
        ],
    },

    {
        key: 'MarketPlaceAddNew',
        authorities: [],
        path: appRoutes.marketPalceRoutes.addNewMarketPlace(),
        component: lazy(() => import('../../views/marketPlace/MarkPlaceDrawer')),
    },
];
